// extracted by mini-css-extract-plugin
export default {"item":"pOlnB__item","chkBox":"iVdHl__chkBox","wrapper":"JzrGv__wrapper","title":"D1bu5__title","editBtn":"kWYep__editBtn"};